import React, { useEffect, useState } from 'react';
import { getAllAnnouncements} from '../../services/announcementsService';
import { getAllTerms } from '../../services/termService';
import { getBatches } from '../../services/studentService';
import axiosInstance from '../../api/axios';

import { Link } from "react-router-dom";
import "./datatable.scss"
import { DataGrid } from '@mui/x-data-grid';

export const AnnouncementList=()=> {
    const [announcements, setAnnouncements] = useState([]);
    const [terms, setTerms] = useState([]);
    const [termMap, setTermMap] = useState({});
    const [batches, setBatches] = useState([]);
    const [degrees, setDegrees] = useState([]);
    const [programs, setPrograms] = useState([]);
    const [degreeMap, setDegreeMap] = useState({});
    const [programMap, setProgramMap] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [filterTermId, setFilterTermId] = useState('');
    const [filterBatch, setFilterBatch] = useState('');
    const [filterDegreeId, setFilterDegreeId] = useState('');
    const [filterProgramId, setFilterProgramId] = useState('');

    const fetchAnnouncements = async () => {
        try {
            const data = await getAllAnnouncements();
          //  console.log(data);
            setAnnouncements(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchFilterOptions = async () => {
        try {
            const [termsRes, batchesRes, degreesRes, programsRes] = await Promise.all([
                getAllTerms(),
                getBatches(),
                axiosInstance.get('/getAllDegrees'),
                axiosInstance.get('/getAllPrograms'),
            ]);
            setTerms(termsRes.data || []);
            setTermMap(Object.fromEntries((termsRes.data || []).map(t => [t.id, t.name])));
            setBatches(batchesRes.data || []);
            setDegrees(degreesRes.data?.data || []);
            setPrograms(programsRes.data?.data || []);
            setDegreeMap(Object.fromEntries((degreesRes.data?.data || []).map(d => [d.id, d.degreeName])));
            setProgramMap(Object.fromEntries((programsRes.data?.data || []).map(p => [p.id, p.programName])));
        } catch (err) {
            console.error('Error fetching filter options:', err);
        }
    };
    useEffect(() => {

        fetchAnnouncements();
        fetchFilterOptions();
    }, []);

    const filteredPrograms = programs.filter(
        p => !filterDegreeId || String(p.degreeId) === String(filterDegreeId)
    );

    const formatColumnData = (value) => {
        if (!value) return value;
    
        // Insert space before each uppercase letter
        let result = value.replace(/([a-z])([A-Z])/g, '$1 $2');
    
        // Capitalize the first letter
        result = result.charAt(0).toUpperCase() + result.slice(1);
    
        return result;
    };
    const transformColumnData = (rows) => {
        return rows.map(row => ({
            ...row,
            submissionType: formatColumnData(row.submissionType),
            announcementType: formatColumnData(row.announcementType),
            termType: formatColumnData(row.termType),
            termName: termMap[row.termId] || row.termId,
            batch: row.batch || 'All Batches',
            degreeName: row.degreeId ? degreeMap[row.degreeId] : 'All Degrees',
            programName: row.programId ? programMap[row.programId] : 'All Programs',
             // Only format this column
        }));
    };
    // A blank degree/program/batch on an announcement means it applies to everyone,
    // so those rows must still match any filter value selected (backward compatible
    // with announcements created before this feature existed).
    const matchesFilter = (rowValue, filterValue) => {
        if (!filterValue) return true;
        if (!rowValue) return true;
        return String(rowValue) === String(filterValue);
    };
    const filteredAnnouncements = announcements.filter(row =>
        matchesFilter(row.termId, filterTermId) &&
        matchesFilter(row.batch, filterBatch) &&
        matchesFilter(row.degreeId, filterDegreeId) &&
        matchesFilter(row.programId, filterProgramId)
    );
    const transformedRows = transformColumnData(filteredAnnouncements);
    const columns = React.useMemo(
        () => [
          //  { field: 'announcementType', headerName: 'Type', width: 180 },
            { field: 'date', headerName: 'Announcement Date', width: 180 },
            { field: 'termName', headerName: 'Term', width: 180 },
            { field: 'batch', headerName: 'Batch', width: 180 },
            { field: 'degreeName', headerName: 'Degree', width: 150 },
            { field: 'programName', headerName: 'Program', width: 180 },
            { field: 'submissionType', headerName: 'Report Type', width: 180 },
            { field: 'termType', headerName: 'Files Type', width: 180 },
            { field: 'submissionDeadline', headerName: 'Submission Deadline', width: 180 },
            { field: 'submissionDeadlinePptvideo', headerName: 'Presentation Deadline', width: 180 }
        ],
        []
    );

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const actionColumn = [{ field: "action", headerName:"Action", width:200,
        renderCell:(params)=>{
            const { id } = params.row;
            return(
                <div className="cellAction">
                    <div className="viewButton"><Link to={{pathname: `/announcements/view-announcement/${id}`}} style={{textDecoration:"none"}}>View</Link></div>
                    <div className="editButton"><Link to={{pathname: `/announcements/edit-announcement/${id}`}} style={{textDecoration:"none" }}>Edit</Link></div>
                </div>
            );
        }
    }]

    const handleDegreeFilterChange = (event) => {
        setFilterDegreeId(event.target.value);
        setFilterProgramId('');
    };

    return (
        <div className="datatable" >
        <div className="datatableTitle">


          <Link to="/announcements/new" className="link" >
          Add Announcement
          </Link>

        </div>

        <div className="datatableTitle" style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
          <select id="styled-dropdown" value={filterTermId} onChange={(e) => setFilterTermId(e.target.value)}>
            <option value="">All Terms</option>
            {terms.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
          <select id="styled-dropdown" value={filterBatch} onChange={(e) => setFilterBatch(e.target.value)}>
            <option value="">All Batches</option>
            {batches.map(b => <option key={b} value={b}>{b}</option>)}
          </select>
          <select id="styled-dropdown" value={filterDegreeId} onChange={handleDegreeFilterChange}>
            <option value="">All Degrees</option>
            {degrees.map(d => <option key={d.id} value={d.id}>{d.degreeName}</option>)}
          </select>
          <select id="styled-dropdown" value={filterProgramId} onChange={(e) => setFilterProgramId(e.target.value)}>
            <option value="">All Programs</option>
            {filteredPrograms.map(p => <option key={p.id} value={p.id}>{p.programName}</option>)}
          </select>
        </div>

      <DataGrid
      rows={transformedRows}
      columns={columns.concat(actionColumn)}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[5, 10]}
      //checkboxSelection
    />
  </div>
    );
}

